import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface MatterportTokenInfo {
  accessToken: string;
  /** Seconds until `accessToken` stops being valid. */
  expiresIn: number;
}

/**
 * Supplies fresh Matterport access tokens for the Showcase SDK token refresher.
 * The host application decides where tokens come from (e.g. its own backend).
 */
export interface MatterportTokenFetcher {
  fetchToken$(): Observable<MatterportTokenInfo>;
}

/**
 * Optional. When provided (together with a stored token expiry), the manager keeps the Showcase session
 * alive by refreshing the token through the SDK before it expires.
 */
export const MATTERPORT_TOKEN_FETCHER =
  new InjectionToken<MatterportTokenFetcher>('MATTERPORT_TOKEN_FETCHER');

export type MatterportTokenRefreshEvent =
  | { type: 'refresh'; token: MatterportTokenInfo }
  | { type: 'error'; error: unknown };
